import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'

import { estimateSelector, estimatedEditedSelector } from '../../redux'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const CarousselImages = () => {
  const estimate = useSelector(estimateSelector)
  const estimateEdited = useSelector(estimatedEditedSelector)

  const pictures = estimate?.pictures || estimateEdited?.pictures || []

  return (
    <Box
      sx={{
        marginTop: '20px',
      }}
    >
      {pictures?.length ? (
        <Swiper
          spaceBetween={5}
          slidesPerView={pictures?.length === 1 ? 1 : 1.8}
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
        >
          {pictures?.map((image: any, i: number) => (
            <SwiperSlide>
              <Box
                key={i}
                sx={{
                  position: 'relative',
                  height: 300,
                  width: '100%',
                  overflow: 'hidden',
                  borderRadius: 2,
                }}
              >
                <img
                  src={image}
                  alt="Uploaded"
                  style={{
                    width: 'auto',
                    height: '100%',
                    display: 'block',
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <></>
      )}
    </Box>
  )
}

export default CarousselImages
